export default {
  ActivityLogImportJob: 'Үйл ажиллагааны бүртгэл импортлох',
  AllSurveysDataMigrationJob: 'Бүх судалгааны өгөгдлийн шилжилт',
  ArenaMobileDataImportJob: 'Arena өгөгдөл импортлох',
  ArenaMobileDataImportSummaryJob: 'Arena өгөгдөл импортлох хураангуй',
  CategoriesImportJob: 'Ангилал импортлох',
  CategoriesValidationJob: 'Ангилал баталгаажуулах',
  CategoriesBatchImportJob: 'Ангилал импортлох',
  CategoryImportJob: 'Ангилал импортлох',
  CategoryImportInternalJob: 'Ангилал импортлох',
  CategoryBatchImportJob: 'Ангилал импортлох',
  CategoryBatchImportInternalJob: 'Ангилал импортлох',
  CategoryValidationJob: 'Ангилал баталгаажуулах',
  ChainsSamplingNodeDefsCheckJob: 'Гинжин хэлхээний дээж авах зангилааны тодорхойлолтуудыг үүсгэх',
  ChainsValidationJob: 'Гинжин хэлхээний баталгаажуулалт',
  ChainsImportJob: 'Гинжин хэлхээ импортлох',
  CollectDataImportJob: 'Collect өгөгдөл импортлох',
  CollectImportJob: 'Collect импортлох',
  CollectSurveyReaderJob: 'Collect судалгаа уншигч',
  CyclesDeletedCheckJob: 'Устгасан мөчлөгийг шалгах',
  DataDeleteJob: 'Өгөгдөл устгах',
  DataImportJob: 'Өгөгдөл импортлох',
  DataImportValidationJob: 'Өгөгдөл импортлох файлын баталгаажуулалт',
  EntitiesDeleteJob: 'Одоо байгаа объектуудыг устгах',
  FilesImportJob: 'Файл импортлох',
  MessageSendJob: 'Мессеж илгээх',
  NodeDefsTranslationJob: 'Зангилааны тодорхойлолтын шошгыг орчуулах',
  NodeDefsImportJob: 'Зангилааны тодорхойлолт импортлох',
  NodeDefsValidationJob: 'Зангилааны тодорхойлолт баталгаажуулах',
  OdkImportJob: 'ODK импортлох',
  OdkDataImportJob: 'ODK өгөгдөл импортлох',
  OdkFormReaderJob: 'ODK маягт уншигч',
  OdkSubmissionReaderJob: 'ODK илгээлт уншигч',
  ChainsCyclesCheckJob: 'Гинжин хэлхээний мөчлөгийг шалгах',
  RecordCheckJob: 'Бичлэг шалгах',
  RecordsCloneJob: 'Бичлэг хуулах',
  RecordsImportJob: 'Бичлэг импортлох',
  RecordsImportSummaryJob: 'Бичлэг импортлох хураангуй',
  RecordsUniquenessValidationJob: 'Бичлэг давтагдахгүй байх баталгаажуулалт',
  SamplingPointDataImportJob: 'Дээж авах цэгийн өгөгдөл импортлох',
  SamplingPointDataImportInternalJob: 'Дээж авах цэгийн өгөгдөл импортлох',
  SchemaSummaryExportJob: 'Схемийн хураангуй экспортлох',
  SelectedRecordsExportJob: 'Сонгосон бичлэгүүдийг экспортлох',
  SurveyActivityLogClearJob: 'Судалгааны үйл ажиллагааны бүртгэлийг цэвэрлэх ажил',
  SurveyCreatorJob: 'Судалгаа үүсгэх',
  SurveyDataMigrationJob: 'Судалгааны өгөгдлийн шилжилт',
  SurveyDependencyGraphsGenerationJob: 'Судалгааны хамаарлын график үүсгэх',
  SurveyExportJob: 'Судалгаа экспортлох',
  SurveyCompareJob: 'Судалгаа харьцуулах',
  SurveyCompareDiffJob: 'Ялгааг тооцоолох',
  SurveyCompareApplyJob: 'Судалгааны өөрчлөлтийг хэрэгжүүлэх',
  SurveyFilesImportJob: 'Судалгааны файлуудыг импортлох',
  SurveyIndexGeneratorJob: 'Судалгааны индекс үүсгэгч',
  SurveyInfoValidationJob: 'Судалгааны мэдээлэл баталгаажуулах',
  SurveyLabelsImportJob: 'Судалгааны шошго импортлох',
  SurveyPropsPublishJob: 'Судалгааны шинж чанарыг нийтлэх',
  SurveyPublishJob: 'Судалгаа нийтлэх',
  SurveyPublishPerformJob: 'Судалгааг нийтлэх ажиллагаа гүйцэтгэх',
  SurveyRdbCreationJob: 'Судалгааны RDB үүсгэх',
  SurveyRdbSchemaCreationJob: 'Судалгааны RDB схем үүсгэх',
  SurveyRdbDataTablesAndViewsCreationJob: 'Судалгааны RDB өгөгдлийн хүснэгт ба харагдац үүсгэх',
  SurveyRdbOlapDataTablesCreationJob: 'Судалгааны RDB OLAP өгөгдлийн хүснэгт үүсгэх',
  SurveyUnpublishJob: 'Судалгааг нийтлэхгүй болгох',
  SurveyPropsUnpublishJob: 'Судалгааны шинж чанарыг нийтлэхгүй болгох',
  SurveysListExportJob: 'Судалгааны жагсаалт экспортлох',
  SurveysRdbRefreshJob: 'Судалгаануудын RDB шинэчлэх',
  TaxonomiesImportJob: 'Таксоном импортлох',
  TaxonomiesValidationJob: 'Таксоном баталгаажуулах',
  TaxonomyImportJob: 'Таксоном импортлох',
  UsersBackupExportJob: 'Хэрэглэгчдийг нөөцлөх',
  UsersBackupImportJob: 'Хэрэглэгчдийг сэргээх',
  // data export
  ArenaFileReadJob: 'Arena файл унших',
  DataExportJob: 'Өгөгдөл экспортлох',
  DataMatrixExportJob: 'Өгөгдлийн матриц экспортлох',
  DataSummaryExportJob: 'Өгөгдлийн хураангуй экспортлох',
  ZipCreationJob: 'ZIP файл үүсгэх',
  CSVDataExtraction: 'Өгөгдөл задлах',
  FilesExportJob: 'Файл экспортлох',
  PrepareImportFileJob: 'Импортын файлыг бэлтгэх',
  // geo
  GeoJsonDataExportJob: 'GeoJson өгөгдөл экспортлох',
  // import arena survey
  ArenaImportJob: 'Arena импортлох',
  ArenaSurveyReaderJob: 'Arena судалгаа уншигч',
  CreateRdbJob: 'Судалгааны RDB үүсгэх',
  UsersImportJob: 'Хэрэглэгч импортлох',
  // clone survey
  SurveyCloneJob: 'Судалгаа хуулах',
  CloneSurveyJob: 'Судалгаа хуулах',
  // survey backup
  SurveyInfoExportJob: 'Судалгааны мэдээлэл экспортлох',
  CategoriesExportJob: 'Ангилал экспортлох',
  CategoryGeoPackageExportJob: 'Ангиллыг GeoPackage рүү экспортлох',
  SamplingPointDataWhispJob: 'Түүвэрлэлтийн цэгийн өгөгдлийн Whisp шинжилгээ',
  SamplingPointDataWhispAnalysisJob: 'Whisp шинжилгээ',
  SamplingPointDataWhispCategoryImportJob: 'Whisp ангилал импортлох',
  TaxonomiesExportJob: 'Таксоном экспортлох',
  RecordsExportJob: 'Бичлэг экспортлох',
  RecordFilesExportJob: 'Бичлэгийн файлуудыг экспортлох',
  SurveyFilesExportJob: 'Судалгааны файлуудыг экспортлох',
  ChainExportJob: 'Гинжин хэлхээ экспортлох',
  UsersExportJob: 'Хэрэглэгч экспортлох',
  ActivityLogExportJob: 'Үйл ажиллагааны бүртгэл экспортлох',
  InfoExportJob: 'Гаралтын файлын мэдээлэл үүсгэх',
  // validation report
  VaidationReportGenerationJob: 'Баталгаажуулалтын тайлан үүсгэх',
  // record Validation
  RecordsValidationJob: 'Бичлэгүүдийн баталгаажуулалт',
  // analysis
  PersistResultsJob: 'Шинжилгээний үр дүнг хадгалах',
  PersistOlapDataJob: 'OLAP өгөгдөл хадгалах',
}
